<div class="dropdown-container">
  <button
    class="dropdown-button"
    (click)="toggleDropdown()"
    aria-haspopup="listbox"
    [attr.aria-expanded]="dropdownOpen"
    aria-controls="idioma-list"
    aria-label="Selecionar idioma"
  >
    {{ selectedIdioma.label }} {{ selectedIdioma.icon }}
    <img src="/assets/icons/down.svg" alt="Ícone de Abrir">
  </button>
  <ul
    id="idioma-list"
    class="dropdown-list"
    [class.show]="dropdownOpen"
    role="listbox"
    aria-label="Lista de idiomas"
  >
    <li
      class="dropdown-item"
      *ngFor="let idioma of idiomas"
      (click)="selectIdioma(idioma)"
      role="option"
      [attr.aria-selected]="idioma === selectedIdioma"
      tabindex="-1"
    >
      {{ idioma.label }} {{ idioma.icon }}
    </li>
  </ul>
</div>


